import { combineReducers } from "redux";

import mefaReducer from "./app/mefa-app/duck";

const rootReducer = combineReducers({
  mefa: mefaReducer
});

export default rootReducer;
